import React from 'react';

import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';

import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------

type RenderFieldNameProps = {
  name: string;
  extension: string;
  hasUnseenAccompanyingDocuments: boolean;
};

const AccompanyingDocumentsTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 180,
  },
});

const RenderNameField: React.FC<RenderFieldNameProps> = ({
  name,
  extension,
  hasUnseenAccompanyingDocuments,
}) => {
  const { t } = useLocales();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <img
        width={30}
        height={30}
        src={`/icons/icon_${extension?.toLowerCase()}.svg`}
        alt={`${extension}`.toUpperCase()}
      />

      <Typography
        sx={{ display: 'flex', justifyContent: 'left', alignItems: 'center', gap: 0.5 }}
        noWrap
      >
        {hasUnseenAccompanyingDocuments && (
          <AccompanyingDocumentsTooltip
            title={t('documents.documentHasUnseenAccompanyingDocuments')}
            placement="top"
            arrow
            slotProps={{
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -6],
                    },
                  },
                ],
              },
            }}
          >
            <AttachFileIcon color="error" />
          </AccompanyingDocumentsTooltip>
        )}

        {name}
      </Typography>
    </Box>
  );
};

export default RenderNameField;
